(() => {
  if (window.DentalCanvasUtmAttributionLoaded) return;
  window.DentalCanvasUtmAttributionLoaded = true;

  const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const STORAGE_KEY = 'dc_utm_attribution';

  const readStored = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (_) {
      return {};
    }
  };

  // Landing UTMs win and then persist: the visitor may browse to other pages
  // before buying, and those later page views carry no query string.
  const resolve = () => {
    const params = new URLSearchParams(window.location.search);
    const stored = readStored();
    const found = {};

    KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) found[key] = value.slice(0, 255);
    });

    if (Object.keys(found).length === 0) return stored;

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
    } catch (_) {
      /* private browsing — attribution is best-effort */
    }
    return found;
  };

  const stamp = (utms) => {
    if (Object.keys(utms).length === 0) return;

    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      KEYS.forEach((key) => {
        const value = utms[key];
        if (!value) return;

        const name = `properties[_${key}]`;
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
      });
    });
  };

  const run = () => stamp(resolve());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Dawn re-renders the product form on variant change and section reload.
  document.addEventListener('shopify:section:load', run);
})();
